import { produce } from 'immer';
import { findIndex, get, mapValues } from 'lodash';
import { Query } from 'redux-little-router';

import { Action } from '../actions';
import {
    ADD_SMART_FILTER,
    CHANGE_SMART_FILTER_TAB,
    CLOSE_GROUP_FILTER_INSPECTOR,
    OPEN_GROUP_FILTER_INSPECTOR,
    SELECT_AUTOBUDGET_PRIORITY_TYPE,
    SET_FILTER_FEED_CATEGORIES,
    SET_SMART_FILTER_VALIDATION_ERRORS,
    TOGGLE_SMART_FILTER_AVAILABLE,
    UPDATE_AUTOBUDGET_PRICE,
    UPDATE_FEED_FILTER_SCHEMA,
    UPDATE_FILTERS_ERROR,
    UPDATE_SMART_FILTER,
    UPDATE_SMART_FILTER_AUDITORY,
    UPDATE_SMART_FILTER_CATEGORIES,
    UPDATE_SMART_FILTER_NAME,
    UPDATE_SMART_FILTER_PRICE_RANGE,
    UPDATE_SMART_FILTER_SUCCESS,
    UPDATE_SMART_FILTER_VENDORS
} from '../actions/groupFilterInspector';
import {
    ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS,
    AcceptMinusPhraseGroupsMassActionsAction
} from '../actions/groups-edit/groups-edit-mass-actions';
import {
    ChangeBannerFeedSearchTextAction,
    PERFORMANCE_CHANGE_BANNER_FEED_SEARCH_TEXT,
    PERFORMANCE_SET_VISIBLE_FEED_MODAL,
    PERFORMANCE_SET_VISIBLE_GROUP_BANNER_POPUP_FEED,
    PERFORMANCE_SUGGEST_FEED_ITEM_CLICK,
    PERFORMANCE_UPDATE_FEEDS,
    SetVisibleGroupBannerPopupFeedAction,
    SuggestFeedItemClickAction
} from '../actions/groups-edit/performance';
import {
    CLOSE_RECOMMENDATIONS_FOR_GROUPS_EDIT,
    CloseRecommendationsForGroupsEditAction,
    UPDATE_RECOMMENDATIONS_FOR_GROUPS_EDIT,
    UpdateRecommendationsForGroupsEditAction
} from '../actions/groups-edit/recommendations';
import {
    CHANGE_AUDIENCE_VALUE,
    CHANGE_CONTENT_PROMOTION_GROUP,
    CHANGE_GENERAL_RATE,
    CHANGE_GROUP_BANNER_HEADERS_FEED_FIELD,
    CHANGE_GROUP_BANNER_TEXT_FEED_FIELD,
    CHANGE_GROUP_EDIT_PAGE_STATUS,
    CHANGE_GROUP_HREF_PARAMS,
    CHANGE_GROUP_NAME,
    CHANGE_GROUP_RETARGETING,
    CHANGE_GROUP_SAVED_STATUS,
    ChangeAudienceValueAction,
    ChangeContentPromotionGroupAction,
    ChangeGeneralRate,
    ChangeGroupBannerHeadersFeedFieldAction,
    ChangeGroupBannerTextFeedFieldAction,
    ChangeGroupHrefParamsAction,
    ChangeGroupName,
    ChangeGroupRetargeting,
    ChangeGroupSavedStatus,
    CLEAR_ERRORS_AUDIENCE_TARGETINGS_NAME,
    CLEAR_ERRORS_GROUP_EDITOR_REGIONS,
    CLEAR_ERRORS_PAGE_GROUP_TAGS,
    CLEAR_ERRORS_TARGET_TAGS,
    ClearErrorsAudienceTargetingsName,
    ClearErrorsGroupEditorRegions,
    ClearErrorsPageGroupTags,
    ClearErrorsTargetTags,
    CLOSE_GROUP_EDIT_RECOMMENDATION,
    CLOSE_GROUP_FILTERS_LIST_EDITOR,
    CREATE_SMART_AD_GROUP,
    DELETE_GROUP_FILTER,
    DELETE_RETARGETING_CONDITION_FROM_GROUP,
    DeleteRetargetingConditionFromGroup,
    GET_CAMPAIGN_BASIC_DATA,
    GET_GROUP_FILTERS,
    GET_GROUPS_FOR_EDIT,
    GROUP_APPLY_CHANGED_MINUS_PHRASE_EDITOR,
    GROUP_DATA_UPDATE_KEYWORDS,
    GroupApplyChangedMinusPhraseEditorAction,
    GroupDataUpdateKeywordsAction,
    MOVE_NEW_GROUP_TO_CREATED,
    MoveNewGroupToCreatedAction,
    OPEN_GROUP_FILTERS_LIST_EDITOR,
    RESET_GROUPS_EDIT,
    RESET_RETARGETING_ERRORS,
    ResetRetargetingErrorsAction,
    SAVE_GROUP_BEHAVIORS_CHANGES,
    SAVE_GROUP_PI_TAGS_EDITOR,
    SAVE_GROUPS,
    SaveGroupBehaviorsChangesAction,
    SaveGroupPITagsEditor,
    SET_GROUP_FILTERS,
    SHOW_GROUP_EDIT_ERROR,
    SHOW_GROUP_EDITOR_REGIONS_ERRORS,
    SHOW_GROUPS_CLIENT_VALIDATION_ERRORS,
    SHOW_GROUPS_PARTIAL_SAVE_RESULT,
    ShowGroupEditorRegionsErrors,
    TOGGLE_GROUP_AUTOTARGETING,
    ToggleGroupAutotargeting,
    UPDATE_AUDIENCE_TARGETINGS,
    UPDATE_DATA_FOR_EDIT_GROUPS,
    UPDATE_FILTERS_EDITOR_AUXILIARY_FILTER,
    UPDATE_GROUP_AUDIENCE_CRYPTA_AUDIO_GENRES,
    UPDATE_GROUP_AUDIENCE_RETARGETING_CONDITION,
    UPDATE_GROUP_EDITOR_REGIONS,
    UPDATE_GROUP_INDOOR_MAP,
    UPDATE_GROUP_MINUS_PHRASES,
    UPDATE_GROUP_OUTDOOR_MAP,
    UPDATE_GROUP_RATE_CORRECTIONS,
    UPDATE_GROUP_TYPE,
    UPDATE_PRODUCT_RESTRICTION_ID,
    UPDATE_PRODUCTS_LIST,
    UPDATE_RETARGETING_CONDITIONS,
    UPDATE_RETARGETING_CONDITIONS_FOR_EDIT_GROUPS,
    UPDATE_SHOW_CONDITION_TYPE,
    UpdateAudienceTargetings,
    UpdateGroupAudienceCryptaAudioGenres,
    UpdateGroupAudienceRetargetingCondition,
    UpdateGroupEditorRegions,
    UpdateGroupIndoorMap,
    UpdateGroupMinusPhrasesAction,
    UpdateGroupOutdoorMap,
    UpdateGroupRateCorrectionsAction,
    UpdateGroupTypeAction,
    UpdateProductRestrictionIdAction,
    UpdateShowConditionTypeAction
} from '../actions/groupsEdit';
import { CLEAR_INDOOR_ERRORS, ClearIndoorErrors } from '../actions/indoorMapEditor';
import { CHANGE_PRIORITY_VALUE } from '../actions/internalGroups/changePriorityValue';
import { DROP_INTERNAL_GROUPS_FIELD_VALIDATION_ERRORS } from '../actions/internalGroups/dropInternalGroupsFieldValidationErrors';
import { SAVE_INTERNAL_GROUPS } from '../actions/internalGroups/saveInternalGroups';
import { CLEAR_OUTDOOR_ERRORS, ClearOutdoorErrors } from '../actions/outdoorMapEditor';
import {
    ADD_SMART_FILTER_CONDITION,
    CHANGE_SMART_FILTER_CONDITION_FIELD,
    CHANGE_SMART_FILTER_CONDITION_OPERATOR,
    CHANGE_SMART_FILTER_CONDITION_VALUES,
    REMOVE_SMART_FILTER_CONDITION
} from '../actions/smartFilterConditions';
import { BulkReplacementRadio } from '../components/BulkReplacementModeChooser/BulkReplacementModeChooser';
import { BEHAVIORS_LTV } from '../constants';
import { getCurrentRateTypeAndLists, makeEmptySmartFilterItem } from '../mappers/group/group';
import { getRestrictionByShowConditionType } from '../mappers/products/products-list-mapper';
import { selectEditGroup } from '../selectors/groupEdit/group/group';
import { getGroupFieldValidationErrors } from '../service/GroupEditErrors/ClientGroupEditErrors/ClientGroupEditErrors';
import { GroupIdsForGroupsEditHelpers } from '../service/GroupIdsForGroupsEditHelpers';
import { PlacementsMapHelpers } from '../service/PlacementsMap/PlacementsMap';
import { RegionsHelpers } from '../service/RegionsHelpers/RegionsHelpers';
import { AudienceTargetingsType } from '../typings/audienceTargetings';
import { ErrorsEdit, PageStatus, ValidationErrorData, ValidationErrorsData } from '../typings/common';
import { CampaignType, GroupType } from '../typings/domain';
import { GdBidModifierType, GdCampaignPlatform, GdStrategyType } from '../typings/graphql-grid';
import { GroupId, GroupsScreenUrlSearchQueryParams } from '../typings/groups';
import {
    CpmGroupShowConditionType,
    EditGroupData,
    EditGroupsState,
    getEditGroupDataValueWithKeywords,
    getEditGroupDataValueWithMinusPhrases,
    MassActionId
} from '../typings/groupsEditState';
import { RetargetingValue } from '../typings/log';
import { MinusPhrasesLibraryItem, MinusPhrasesShortLibraryItem } from '../typings/minusPhraseLibrary';
import { State } from '../typings/state';

import { conditionsReducer } from './groups-edit/conditions';
import { filtersReducer } from './groups-edit/filters';
import { groupFilterInspectorReducer } from './groups-edit/groupFilterInspector';
import { groupsEditPreviewBannersReducer } from './groups-edit/preview-banners';
import { internalGroups } from './internalGroups';

export interface EditGroupPageLocalAndUrlData {
    campaignsIds: string[];
    groupsIds: string[];
    isNew: boolean;
    isNewEmptyGroup: boolean;
}

export const getEditGroupPageData = (queryParams: Query): EditGroupPageLocalAndUrlData => {
    const editGroupsLocalData = GroupIdsForGroupsEditHelpers.getCampAndGroupIds(queryParams.ulogin);

    const editGroupDataFromUrl = {
        campaignsIds: queryParams[GroupsScreenUrlSearchQueryParams.campaignsIds]
            ? queryParams[GroupsScreenUrlSearchQueryParams.campaignsIds].split(',')
            : [],
        groupsIds: queryParams[GroupsScreenUrlSearchQueryParams.groupsIds]
            ? queryParams[GroupsScreenUrlSearchQueryParams.groupsIds].split(',')
            : [],
        isNew: queryParams[GroupsScreenUrlSearchQueryParams.isNew]
            ? Boolean(+queryParams[GroupsScreenUrlSearchQueryParams.isNew])
            : false,
        isNewEmptyGroup: queryParams[GroupsScreenUrlSearchQueryParams.isNewEmptyGroup]
            ? Boolean(+queryParams[GroupsScreenUrlSearchQueryParams.isNewEmptyGroup])
            : false
    };

    const hasNotEmptyEditGroupDataFromUrl =
        editGroupDataFromUrl.campaignsIds.length !== 0 || editGroupDataFromUrl.groupsIds.length !== 0;

    return hasNotEmptyEditGroupDataFromUrl ? editGroupDataFromUrl : editGroupsLocalData;
};

export const EditGroupsInitialState: EditGroupsState = {
    pageStatus: PageStatus.LOADING,
    errors: [],
    groups: {},
    groupFilterInspector: {
        filter: makeEmptySmartFilterItem({
            platform: GdCampaignPlatform.BOTH,
            strategy: GdStrategyType.AVG_CPC_PER_CAMP
        }),
        isOpen: false,
        inspectorStatus: PageStatus.LOADED,
        schema: {
            fields: []
        }
    },
    groupsIds: [],
    campaignsIds: [],
    isNew: false,
    isNewEmptyGroup: false,
    retargetingConditions: undefined,
    recommendations: {},
    feedsIds: [],
    feeds: {},
    feedsPopupFetchFirstRun: true,
    isPerformanceFeedModalOpen: false,
    allowedRateCorrectionsData: {} as Record<GroupType, Array<GdBidModifierType>>,
    rateCorrectionsConstants: {},
    keywordsCountLimit: 0
};

const changeAudienceValue = (state: EditGroupsState, action: ChangeAudienceValueAction): EditGroupsState => {
    const group = selectEditGroup(state, action.groupId);
    const groupValue = group.value;

    if (groupValue.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(`В кампании с типом ${groupValue.campaignType} нет возможности установить охват группы`);
    }

    const audienceCollection = action.value;

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...groupValue,
                    audienceCollection
                }
            }
        }
    };
};

const updateGroupName = (state: EditGroupsState, action: ChangeGroupName): EditGroupsState => {
    const { name, ...otherFieldsGroupErrors } = state.groups[action.groupId].errors;

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...state.groups[action.groupId],
                value: {
                    ...state.groups[action.groupId].value,
                    name: action.name
                },
                errors: otherFieldsGroupErrors
            }
        }
    };
};

const updateGroupType = (state: EditGroupsState, action: UpdateGroupTypeAction): EditGroupsState => {
    const {
        group: { restrictionId }
    } = action;
    const { name, ...otherFieldsGroupErrors } = state.groups[action.groupId].errors;
    const { groups, productsList } = state;
    const group = groups[action.groupId];

    if (group.value.campaignType !== CampaignType.CPM_BANNER || productsList === undefined) {
        throw Error(`В группе с типом ${group.value.campaignType} нет возможности изменить тип обьявления`);
    }

    const { rateCurrentType, rateCorrections } = getCurrentRateTypeAndLists({
        productRestrictionId: restrictionId,
        rateCorrectionsFromApi: [],

        productsList: productsList
    });

    return {
        ...state,
        groups: {
            ...groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...group.value,
                    rateCurrentType,
                    rateCorrections,
                    groupType: action.group.groupType
                },
                errors: otherFieldsGroupErrors
            }
        }
    };
};

const updateGroupGeneralRate = (state: EditGroupsState, action: ChangeGeneralRate): EditGroupsState => {
    const newGroupData = {
        ...state.groups[action.groupId],
        value: {
            ...state.groups[action.groupId].value,
            generalRate: action.generalRate
        }
    };
    const validationErrors = getGroupFieldValidationErrors(newGroupData, 'generalRate', action.validationParams);
    const { generalRate, ...otherFieldsGroupErrors } = state.groups[action.groupId].errors;

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...newGroupData,
                errors:
                    validationErrors.length === 0
                        ? otherFieldsGroupErrors
                        : {
                              ...otherFieldsGroupErrors,
                              generalRate: { errors: validationErrors }
                          }
            }
        }
    };
};

const doneChangesGroupMinusKeywordsEditor = (
    state: EditGroupsState,
    action: GroupApplyChangedMinusPhraseEditorAction
): EditGroupsState => {
    if (action.groupId === MassActionId.groupsEdit) {
        return state;
    }

    const group = state.groups[action.groupId];
    const { minusKeywordsEditor, libraryItems } = action;
    const groupValue = getEditGroupDataValueWithMinusPhrases(group.value);
    if (!groupValue) {
        throw new Error('invalid group type');
    }

    if (minusKeywordsEditor.selectedLibraryListItems) {
        const selectedLibraryList = minusKeywordsEditor.selectedLibraryListItems.reduce<MinusPhrasesShortLibraryItem[]>(
            (selectedElems: MinusPhrasesShortLibraryItem[], id: string): MinusPhrasesShortLibraryItem[] => {
                const selectedItem = libraryItems.find((item: MinusPhrasesLibraryItem) => item.id === id);

                if (selectedItem) {
                    selectedElems.push({
                        id,
                        name: selectedItem.name
                    });
                }

                return selectedElems;
            },
            []
        );

        return {
            ...state,
            groups: {
                ...state.groups,
                [action.groupId]: {
                    ...group,
                    value: {
                        ...groupValue,
                        minusKeywords: minusKeywordsEditor.value,
                        selectedLibraryList
                    }
                }
            }
        };
    } else {
        return {
            ...state,
            groups: {
                ...state.groups,
                [action.groupId]: {
                    ...group,
                    value: {
                        ...groupValue,
                        minusKeywords: minusKeywordsEditor.value
                    }
                }
            }
        };
    }
};

const setSavedGroups = (
    state: EditGroupsState,
    updatedGroupIds: Array<GroupId>,
    errors: ErrorsEdit
): EditGroupsState => {
    if (updatedGroupIds.length) {
        const groups = { ...state.groups };

        updatedGroupIds.forEach(groupId => {
            groups[groupId] = {
                ...state.groups[groupId],
                isSaved: true
            };
        });

        state = {
            ...state,
            groups
        };
    }

    if (errors.common) {
        state = {
            ...state,
            pageStatus: PageStatus.LOADED,
            errors: [...state.errors, ...get(errors, 'common.errors').map(({ text }: ValidationErrorData) => text)]
        };
    }

    if (errors.groups) {
        Object.keys(errors.groups).forEach(groupId => {
            if (groupId !== 'errors') {
                const errorsObj = get(errors, `groups[${groupId}]`, []);
                const group = state.groups[groupId];

                state = {
                    ...state,
                    pageStatus: PageStatus.LOADED,
                    groups: {
                        ...state.groups,
                        [groupId]: {
                            ...group,
                            isSaved: false,
                            errors: errorsObj
                        }
                    }
                };
            }
        });
    }

    return state;
};

const updateGroupSavedStatus = (state: EditGroupsState, action: ChangeGroupSavedStatus): EditGroupsState => {
    const group = state.groups[action.groupId];

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                isSaved: !group.isSaved
            }
        }
    };
};

const groupDataUpdateKeywordsReducer = (
    state: EditGroupsState,
    action: GroupDataUpdateKeywordsAction
): EditGroupsState => {
    const group = state.groups[action.groupId];
    const groupValue = getEditGroupDataValueWithKeywords(group.value);
    if (!groupValue) {
        throw new Error('invalid group type');
    }

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...groupValue,
                    keywords: action.payload
                }
            }
        }
    };
};

const groupDataUpdateMinusPhrasesReducer = (
    state: EditGroupsState,
    action: UpdateGroupMinusPhrasesAction
): EditGroupsState => {
    const group = state.groups[action.groupId];
    const groupValue = getEditGroupDataValueWithMinusPhrases(group.value);
    if (!groupValue) {
        throw new Error('invalid group type');
    }

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...groupValue,
                    minusKeywords: action.minusPhrases
                }
            }
        }
    };
};

const updateRecommendationData = (
    state: EditGroupsState,
    action: UpdateRecommendationsForGroupsEditAction
): EditGroupsState => {
    return {
        ...state,
        recommendations: action.recommendations
    };
};

const closeGroupsEditRecommendations = (
    state: EditGroupsState,
    action: CloseRecommendationsForGroupsEditAction
): EditGroupsState => {
    const recommendation = state.recommendations[action.id];

    return {
        ...state,
        recommendations: {
            ...state.recommendations,
            [action.id]: {
                ...recommendation,
                isRecommendationsVisible: false
            }
        }
    };
};

const getGroupsErrorsWithoutCurrentListErrors = (
    errors: ValidationErrorsData,
    currentListErrors: Array<string>
): ValidationErrorsData => {
    return Object.keys(errors).reduce((acc, errorKey) => {
        if (!currentListErrors.includes(errorKey)) {
            acc[errorKey] = errors[errorKey];
        }
        return acc;
    }, {});
};

const updateRateCorrections = (state: EditGroupsState, action: UpdateGroupRateCorrectionsAction): EditGroupsState => {
    const group = state.groups[action.groupId];
    const groupValue = group.value;

    if (
        groupValue.campaignType !== CampaignType.TEXT &&
        groupValue.campaignType !== CampaignType.PERFORMANCE &&
        groupValue.campaignType !== CampaignType.CPM_BANNER &&
        groupValue.campaignType !== CampaignType.MCBANNER &&
        groupValue.campaignType !== CampaignType.CONTENT_PROMOTION
    ) {
        throw Error(`В кампании с типом ${groupValue.campaignType} нет возможности установить корректировки ставок`);
    }

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...groupValue,
                    rateCorrections: action.rateCorrections
                }
            }
        }
    };
};

const updateGroupAudienceRetargetingCondition = (
    state: EditGroupsState,
    action: UpdateGroupAudienceRetargetingCondition
): EditGroupsState => {
    const group = state.groups[action.id];
    const groupValue = group.value;

    if (groupValue.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(
            `В кампании с типом ${groupValue.campaignType} нет возможности установить Яндекс.Аудитории и Яндекс.Метрика`
        );
    }

    const audienceTargetings = groupValue.audienceTargetings || {};

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                value: {
                    ...groupValue,
                    audienceTargetings: {
                        ...audienceTargetings,
                        [AudienceTargetingsType.audienceMetrics]: action.conditionData
                    }
                },
                errors: getGroupsErrorsWithoutCurrentListErrors(group.errors, ['retargetingCondition'])
            }
        }
    };
};

const updateGroupOutdoorMap = (state: EditGroupsState, action: UpdateGroupOutdoorMap): EditGroupsState => {
    const group = state.groups[action.id];
    const groupValue = group.value;

    if (groupValue.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(`В кампании с типом ${groupValue.groupType} нет возможности установить рекламные поверхности`);
    }

    const outdoorMap = groupValue.outdoorMap || {};

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                value: {
                    ...groupValue,
                    outdoorMap: {
                        ...outdoorMap,
                        pageBlocks: PlacementsMapHelpers.checkedByRegionToPageBlocks(action.checkedByRegion)
                    }
                }
            }
        }
    };
};

const clearGroupMapErrors = (
    state: EditGroupsState,
    action: ClearIndoorErrors | ClearOutdoorErrors
): EditGroupsState => {
    const group = state.groups[action.id];

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                errors: {
                    ...group.errors,
                    pageBlocks: {
                        errors: []
                    }
                }
            }
        }
    };
};

const updateGroupIndoorMap = (state: EditGroupsState, action: UpdateGroupIndoorMap): EditGroupsState => {
    const group = state.groups[action.id];
    const groupValue = group.value;

    if (groupValue.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(`В кампании с типом ${groupValue.groupType} нет возможности установить рекламные поверхности`);
    }

    const indoorMap = groupValue.indoorMap || {};

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                value: {
                    ...groupValue,
                    indoorMap: {
                        ...indoorMap,
                        pageBlocks: PlacementsMapHelpers.indoorCheckedByRegionToPageBlocks(
                            action.screenGroupsByRegion,
                            action.checkedByRegion
                        )
                    }
                }
            }
        }
    };
};

const updateAudienceTargeting = (state: EditGroupsState, action: UpdateAudienceTargetings): EditGroupsState => {
    const group = state.groups[action.id];
    const groupValue = group.value;

    if (
        groupValue.campaignType !== CampaignType.CPM_BANNER &&
        groupValue.campaignType !== CampaignType.TEXT &&
        groupValue.campaignType !== CampaignType.CPM_PRICE
    ) {
        throw Error(`В кампании с типом ${groupValue.campaignType} нет возможности установить таргетинги`);
    }

    const audienceTargetings = groupValue.audienceTargetings || {};

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                value: {
                    ...groupValue,
                    audienceTargetings: {
                        ...audienceTargetings,
                        ...action.value
                    },
                    audienceTargetingsTemplateName: action.name
                },
                errors: getGroupsErrorsWithoutCurrentListErrors(group.errors, ['retargetingConditionName'])
            }
        }
    };
};

const toggleGroupAutotargeting = (state: EditGroupsState, action: ToggleGroupAutotargeting): EditGroupsState => {
    return produce(state, draft => {
        const group = draft.groups[action.groupId];

        if (
            group.value.campaignType !== CampaignType.TEXT &&
            group.value.campaignType !== CampaignType.CONTENT_PROMOTION
        ) {
            throw Error(`В кампании с типом ${group.value.campaignType} нет возможности установить автотаргетинг`);
        }

        group.value.autotargeting.isActive = !group.value.autotargeting.isActive;
    });
};

const updateGroupRetargeting = (state: EditGroupsState, action: ChangeGroupRetargeting): EditGroupsState => {
    const group = state.groups[action.groupId];

    if (group.value.campaignType !== CampaignType.TEXT) {
        throw Error(`В кампании с типом ${group.value.campaignType} нет возможности установить условия ретаргетинга`);
    }

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...group.value,
                    retargeting: action.value
                }
            }
        }
    };
};

const updateGroupHrefParams = (state: EditGroupsState, action: ChangeGroupHrefParamsAction): EditGroupsState => {
    const group = state.groups[action.groupId];

    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            hrefParams: action.params
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const updateGroupBannerHeadersFeedField = (
    state: EditGroupsState,
    action: ChangeGroupBannerHeadersFeedFieldAction
): EditGroupsState => {
    const group = state.groups[action.groupId];

    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            bannerHeadersFeedField: action.payload
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const updateCryptaAudioGenres = (
    state: EditGroupsState,
    action: UpdateGroupAudienceCryptaAudioGenres
): EditGroupsState => {
    const group = state.groups[action.id];
    const groupValue = group.value;

    if (groupValue.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(`В кампании с типом ${groupValue.campaignType} нет возможности установить данные о жанрах`);
    }

    const audienceTargetings = groupValue.audienceTargetings || {};

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                value: {
                    ...groupValue,
                    audienceTargetings: {
                        ...audienceTargetings,
                        [AudienceTargetingsType.audioGenres]: action.audioGenres
                    }
                }
            }
        }
    };
};

const updateGroupBannerTextFeedField = (
    state: EditGroupsState,
    action: ChangeGroupBannerTextFeedFieldAction
): EditGroupsState => {
    const group = state.groups[action.groupId];

    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            bannerTextFeedField: action.payload
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const performanceSetVisibleGroupBannerPopupFeed = (
    state: EditGroupsState,
    action: SetVisibleGroupBannerPopupFeedAction
): EditGroupsState => {
    const group = state.groups[action.groupId];

    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            feedsPopupIsOpen: action.isVisible
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const performanceChangeBannerFeedSearchText = (
    state: EditGroupsState,
    action: ChangeBannerFeedSearchTextAction
): EditGroupsState => {
    const group = state.groups[action.groupId];

    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            searchFeedFieldValue: action.value
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const updateGroupEditorRegions = (state: EditGroupsState, action: UpdateGroupEditorRegions): EditGroupsState => {
    const group = state.groups[action.groupId];

    const regionIds = RegionsHelpers.convertRegionsSelectedInfoToFlattenList(
        RegionsHelpers.getSelectedRegionsInfo(action.tree, action.selectedMap)
    );

    switch (group.value.campaignType) {
        case CampaignType.TEXT:
        case CampaignType.PERFORMANCE:
        case CampaignType.INTERNAL_FREE:
        case CampaignType.INTERNAL_DISTRIB:
        case CampaignType.INTERNAL_AUTOBUDGET:
        case CampaignType.CPM_BANNER:
        case CampaignType.MCBANNER:
        case CampaignType.CONTENT_PROMOTION:
        case CampaignType.CPM_PRICE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            regions: {
                                ...group.value.regions,
                                selectedMap: action.selectedMap,
                                regionIds: regionIds
                            }
                        }
                    }
                }
            };
        default:
            return state;
    }
};

const showGroupEditorRegionsErrors = (
    state: EditGroupsState,
    action: ShowGroupEditorRegionsErrors
): EditGroupsState => {
    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...state.groups[action.groupId],
                errors: {
                    ...state.groups[action.groupId].errors,
                    regionIds: { errors: action.errors }
                }
            }
        }
    };
};

const performanceSuggestFeedItemClick = (
    state: EditGroupsState,
    action: SuggestFeedItemClickAction
): EditGroupsState => {
    const group = state.groups[action.groupId];
    const { feedId, ...rest } = group.errors;

    switch (group.value.campaignType) {
        case CampaignType.PERFORMANCE:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...group,
                        value: {
                            ...group.value,
                            selectedFeedId: action.feedId
                        },
                        errors: rest
                    }
                }
            };
        default:
            return state;
    }
};

const clearErrorsGroupEditorRegions = (
    state: EditGroupsState,
    action: ClearErrorsGroupEditorRegions
): EditGroupsState => {
    const group = state.groups[action.groupId];
    const { errors } = group;

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                errors: getGroupsErrorsWithoutCurrentListErrors(errors, ['regionIds'])
            }
        }
    };
};

const moveNewGroupToCreatedReducer = (state: EditGroupsState, action: MoveNewGroupToCreatedAction): EditGroupsState => {
    const group = state.groups[action.mockGroupId];

    if (group.value.campaignType !== CampaignType.PERFORMANCE) {
        return state;
    }

    return {
        ...state,
        errors: [],
        groups: {
            [action.realGroupId]: {
                ...group,
                value: {
                    ...group.value,
                    feedId: action.feedId
                },
                id: action.realGroupId,
                isNew: false
            }
        }
    };
};

const deleteRetargetingConditionFromGroup = (
    state: EditGroupsState,
    action: DeleteRetargetingConditionFromGroup
): EditGroupsState => {
    if (state.retargetingConditions === undefined) {
        return {
            ...state
        };
    }

    const newRetargetingConditions = [...state.retargetingConditions];
    newRetargetingConditions.splice(action.index, 1);

    return {
        ...state,
        retargetingConditions: newRetargetingConditions
    };
};

const resetRetargetingErrors = (state: EditGroupsState, action: ResetRetargetingErrorsAction): EditGroupsState => {
    const group = state.groups[action.groupId];

    const { retargeting, ...otherGroupErrors } = group.errors;

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                errors: otherGroupErrors
            }
        }
    };
};

const setNewMinusPhraseDataByMassActions = (
    state: EditGroupsState,
    action: AcceptMinusPhraseGroupsMassActionsAction,
    fullState: State
): EditGroupsState => {
    const groups = state.groups;
    const { minusPhrasesRadio } = fullState.groupsEditMassActions[MassActionId.groupsEdit].data;
    const { value, selectedLibraryListItems = [] } = fullState.minusPhraseLibraryEditor.data[
        action.massActionId
    ].minusKeywordsEditor;

    const newGroupsData = Object.keys(groups).reduce((acc: Record<GroupId, EditGroupData>, next) => {
        const libraryItems = fullState.minusPhraseLibraryEditor.libraryItems || [];

        let newSelectedLibraryList: MinusPhrasesShortLibraryItem[] = [];
        let newValue: string[] = [];

        if (minusPhrasesRadio === BulkReplacementRadio.REPLACE) {
            newSelectedLibraryList = selectedLibraryListItems.reduce(
                (selectedElems: MinusPhrasesShortLibraryItem[], id: string): MinusPhrasesShortLibraryItem[] => {
                    const selectedItem = libraryItems.find((item: MinusPhrasesLibraryItem) => item.id === id);

                    if (selectedItem) {
                        selectedElems.push({
                            id,
                            name: selectedItem.name
                        });
                    }

                    return selectedElems;
                },
                [] as MinusPhrasesShortLibraryItem[]
            );
            newValue = value;
        }

        const group: EditGroupData = groups[next];

        if (
            (group.value.campaignType === CampaignType.TEXT || group.value.campaignType === CampaignType.MCBANNER) &&
            group.isEditable
        ) {
            acc[next] = {
                ...group,
                value: {
                    ...group.value,
                    minusKeywords: newValue,
                    selectedLibraryList: newSelectedLibraryList
                },
                errors: {},
                isSaved: false
            };
        } else {
            acc[next] = group;
        }

        return acc;
    }, {});

    return {
        ...state,
        groups: newGroupsData
    };
};

const updateProductsRestrictionId = (
    state: EditGroupsState,
    action: UpdateProductRestrictionIdAction
): EditGroupsState => {
    const group = state.groups[action.groupId];

    if (group.value.campaignType !== CampaignType.CPM_BANNER) {
        throw Error(`В группе с типом ${group.value.campaignType} нет возможности изменить набор условий показа`);
    }

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...group.value,
                    showConditionType: CpmGroupShowConditionType.USER_PROFILE,
                    productRestrictionId: action.id
                },
                errors: {}
            }
        }
    };
};

const saveGroupPITags = (state: EditGroupsState, action: SaveGroupPITagsEditor): EditGroupsState => {
    return produce(state, draft => {
        let piTags = draft.groups[action.id].value.piTagsEditor;

        if (!piTags) {
            piTags = {};
        }

        piTags.targetTags = action.targetTags;
        piTags.pageGroupTags = action.pageTags;
    });
};

const updateShowConditionType = (state: EditGroupsState, action: UpdateShowConditionTypeAction): EditGroupsState => {
    const { groups, productsList } = state;
    const group = groups[action.groupId];

    if (group.value.campaignType !== CampaignType.CPM_BANNER || productsList === undefined) {
        throw Error(`В группе с типом ${group.value.campaignType} нет возможности изменить набор условий показа`);
    }

    const restrictions = productsList[CampaignType.CPM_BANNER].restrictions;
    const restrictionByShowConditionType = getRestrictionByShowConditionType(action.showConditionType, restrictions);
    const productRestrictionId = restrictionByShowConditionType
        ? restrictionByShowConditionType.id
        : group.value.productRestrictionId;
    const { rateCurrentType, rateCorrections } = getCurrentRateTypeAndLists({
        productRestrictionId: productRestrictionId,
        rateCorrectionsFromApi: [],
        productsList: productsList
    });

    return {
        ...state,
        groups: {
            ...state.groups,
            [action.groupId]: {
                ...group,
                value: {
                    ...group.value,
                    rateCurrentType,
                    rateCorrections,
                    showConditionType: action.showConditionType,
                    productRestrictionId
                }
            }
        }
    };
};

const clearErrorsAudienceTargetingsName = (
    state: EditGroupsState,
    action: ClearErrorsAudienceTargetingsName
): EditGroupsState => {
    const group = state.groups[action.id];
    const groupValue = group.value;

    if (
        groupValue.campaignType !== CampaignType.CPM_BANNER &&
        groupValue.campaignType !== CampaignType.TEXT &&
        groupValue.campaignType !== CampaignType.CPM_PRICE
    ) {
        throw Error(`В кампании с типом ${groupValue.campaignType} нет возможности установить таргетинги`);
    }
    return {
        ...state,
        groups: {
            ...state.groups,
            [action.id]: {
                ...group,
                errors: getGroupsErrorsWithoutCurrentListErrors(group.errors, ['retargetingConditionName'])
            }
        }
    };
};

const clearErrorsPageGroupTags = (state: EditGroupsState, action: ClearErrorsPageGroupTags): EditGroupsState => {
    return produce(state, draft => {
        const group = draft.groups[action.id];

        draft.groups[action.id].errors = getGroupsErrorsWithoutCurrentListErrors(group.errors, ['pageGroupTags']);
    });
};

const clearErrorsTargetTags = (state: EditGroupsState, action: ClearErrorsTargetTags): EditGroupsState => {
    return produce(state, draft => {
        const group = draft.groups[action.id];

        draft.groups[action.id].errors = getGroupsErrorsWithoutCurrentListErrors(group.errors, ['targetTags']);
    });
};

const changeContentPromotionGroup = (
    state: EditGroupsState,
    action: ChangeContentPromotionGroupAction
): EditGroupsState => {
    return produce(state, draft => {
        draft.groups[action.groupId].value.groupType = action.groupType;
    });
};

const saveGroupBehaviors = (state: EditGroupsState, action: SaveGroupBehaviorsChangesAction): EditGroupsState => {
    return produce(state, draft => {
        const group = draft.groups[action.id];
        const groupValue = group.value;

        if (groupValue.campaignType !== CampaignType.CPM_PRICE) {
            throw Error(
                `В кампании с типом ${groupValue.campaignType} нет возможности установить дополнительные таргетинги`
            );
        }

        if (action.checked) {
            groupValue.behaviors = [BEHAVIORS_LTV];
        } else {
            groupValue.behaviors = [];
        }
    });
};

function _groupsMultiEdit(state: EditGroupsState, action: Action, fullState: State): EditGroupsState {
    switch (action.type) {
        case RESET_GROUPS_EDIT:
            return EditGroupsInitialState;

        case ACCEPT_MINUS_PHRASE_GROUPS_MASS_ACTIONS:
            return setNewMinusPhraseDataByMassActions(state, action, fullState);
        case GET_GROUPS_FOR_EDIT:
            return {
                ...state,
                pageStatus: PageStatus.LOADING
            };

        case GET_CAMPAIGN_BASIC_DATA:
            return {
                ...state,
                campaignsIds: [action.campaignId],
                pageStatus: PageStatus.LOADING,
                feedsPopupFetchFirstRun: true
            };

        case CREATE_SMART_AD_GROUP:
            return {
                ...state,
                errors: [],
                groups: {
                    ...state.groups,
                    [action.mockGroupId]: {
                        ...state.groups[action.mockGroupId],
                        errors: {}
                    }
                },
                pageStatus: PageStatus.SAVING
            };

        case SAVE_GROUPS:
            return {
                ...state,
                errors: [],
                pageStatus: PageStatus.SAVING
            };

        case UPDATE_DATA_FOR_EDIT_GROUPS:
            return {
                ...state,
                ...action.data,
                pageStatus: PageStatus.LOADED
            };

        case UPDATE_PRODUCTS_LIST:
            return {
                ...state,
                productsList: action.productsList
            };

        case UPDATE_RETARGETING_CONDITIONS_FOR_EDIT_GROUPS: {
            return {
                ...state,
                retargetingConditions: action.data.retargetingConditions
            };
        }

        case UPDATE_RETARGETING_CONDITIONS: {
            if (state.retargetingConditions === undefined) {
                return {
                    ...state
                };
            }

            let newRetargetingConditions = [...state.retargetingConditions];
            let newGroups = state.groups;

            const conditionIndex = findIndex(newRetargetingConditions, condition => {
                return condition.id === action.condition.id;
            });

            if (conditionIndex !== -1) {
                newRetargetingConditions[conditionIndex] = action.condition;

                newGroups = mapValues(state.groups, group => {
                    if (group.value.campaignType !== CampaignType.TEXT) {
                        return group;
                    }

                    return {
                        ...group,
                        value: {
                            ...group.value,
                            retargeting: group.value.retargeting.map((retargetingItem: RetargetingValue) => {
                                if (retargetingItem.id === action.condition.id) {
                                    return {
                                        id: retargetingItem.id
                                    };
                                }

                                return retargetingItem;
                            })
                        }
                    };
                });
            } else {
                newRetargetingConditions = [...newRetargetingConditions, action.condition];
            }

            return {
                ...state,
                retargetingConditions: newRetargetingConditions,
                groups: newGroups
            };
        }

        case CHANGE_GROUP_NAME:
            return updateGroupName(state, action);

        case UPDATE_GROUP_TYPE:
            return updateGroupType(state, action);

        case CHANGE_GENERAL_RATE:
            return updateGroupGeneralRate(state, action);

        case CHANGE_AUDIENCE_VALUE:
            return changeAudienceValue(state, action);

        case SHOW_GROUP_EDIT_ERROR:
            return {
                ...state,
                errors: [...state.errors, String(action.error.text)],
                pageStatus: PageStatus.LOADED
            };

        case CHANGE_GROUP_EDIT_PAGE_STATUS:
            return {
                ...state,
                pageStatus: action.pageStatus
            };

        case GROUP_APPLY_CHANGED_MINUS_PHRASE_EDITOR:
            return doneChangesGroupMinusKeywordsEditor(state, action);

        case SHOW_GROUPS_PARTIAL_SAVE_RESULT:
            return {
                ...state,
                ...setSavedGroups(state, action.payload.updatedGroupIds, action.payload.errors)
            };

        case SHOW_GROUPS_CLIENT_VALIDATION_ERRORS:
            return {
                ...state,
                pageStatus: PageStatus.LOADED,
                groups: mapValues(state.groups, group => {
                    return {
                        ...group,
                        errors: action.errorsData[group.id] ? action.errorsData[group.id] : group.errors
                    };
                })
            };

        case CLOSE_GROUP_EDIT_RECOMMENDATION:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.groupId]: {
                        ...state.groups[action.groupId],
                        showConditionsRecommendationData: {
                            wasClosed: true
                        }
                    }
                }
            };

        case UPDATE_PRODUCT_RESTRICTION_ID:
            return updateProductsRestrictionId(state, action);

        case UPDATE_SHOW_CONDITION_TYPE:
            return updateShowConditionType(state, action);

        case CHANGE_GROUP_SAVED_STATUS:
            return updateGroupSavedStatus(state, action);

        case GROUP_DATA_UPDATE_KEYWORDS:
            return groupDataUpdateKeywordsReducer(state, action);

        case UPDATE_GROUP_MINUS_PHRASES:
            return groupDataUpdateMinusPhrasesReducer(state, action);

        case UPDATE_GROUP_RATE_CORRECTIONS:
            return updateRateCorrections(state, action);

        case UPDATE_GROUP_AUDIENCE_RETARGETING_CONDITION:
            return updateGroupAudienceRetargetingCondition(state, action);

        case UPDATE_GROUP_OUTDOOR_MAP:
            return updateGroupOutdoorMap(state, action);

        case UPDATE_GROUP_INDOOR_MAP:
            return updateGroupIndoorMap(state, action);

        case CLEAR_OUTDOOR_ERRORS:
        case CLEAR_INDOOR_ERRORS:
            return clearGroupMapErrors(state, action);

        case UPDATE_GROUP_AUDIENCE_CRYPTA_AUDIO_GENRES:
            return updateCryptaAudioGenres(state, action);

        case UPDATE_AUDIENCE_TARGETINGS:
            return updateAudienceTargeting(state, action);

        case TOGGLE_GROUP_AUTOTARGETING:
            return toggleGroupAutotargeting(state, action);

        case CHANGE_GROUP_RETARGETING: {
            return updateGroupRetargeting(state, action);
        }

        case CHANGE_GROUP_HREF_PARAMS:
            return updateGroupHrefParams(state, action);

        case CHANGE_GROUP_BANNER_HEADERS_FEED_FIELD:
            return updateGroupBannerHeadersFeedField(state, action);

        case PERFORMANCE_SET_VISIBLE_GROUP_BANNER_POPUP_FEED:
            return performanceSetVisibleGroupBannerPopupFeed(state, action);

        case PERFORMANCE_CHANGE_BANNER_FEED_SEARCH_TEXT:
            return performanceChangeBannerFeedSearchText(state, action);

        case PERFORMANCE_SUGGEST_FEED_ITEM_CLICK:
            return performanceSuggestFeedItemClick(state, action);

        case CHANGE_GROUP_BANNER_TEXT_FEED_FIELD:
            return updateGroupBannerTextFeedField(state, action);

        case CLEAR_ERRORS_AUDIENCE_TARGETINGS_NAME:
            return clearErrorsAudienceTargetingsName(state, action);

        case OPEN_GROUP_FILTERS_LIST_EDITOR:
        case CLOSE_GROUP_FILTERS_LIST_EDITOR:
        case SET_GROUP_FILTERS:
        case GET_GROUP_FILTERS:
        case DELETE_GROUP_FILTER:
        case UPDATE_FILTERS_EDITOR_AUXILIARY_FILTER:
            return filtersReducer(state, action, fullState);

        case PERFORMANCE_SET_VISIBLE_FEED_MODAL:
            return {
                ...state,
                isPerformanceFeedModalOpen: action.isVisible
            };

        case ADD_SMART_FILTER_CONDITION:
        case REMOVE_SMART_FILTER_CONDITION:
        case CHANGE_SMART_FILTER_CONDITION_OPERATOR:
        case CHANGE_SMART_FILTER_CONDITION_FIELD:
        case CHANGE_SMART_FILTER_CONDITION_VALUES:
            return conditionsReducer(state, action);

        case UPDATE_GROUP_EDITOR_REGIONS:
            return updateGroupEditorRegions(state, action);

        case CLEAR_ERRORS_GROUP_EDITOR_REGIONS:
            return clearErrorsGroupEditorRegions(state, action);

        case SHOW_GROUP_EDITOR_REGIONS_ERRORS:
            return showGroupEditorRegionsErrors(state, action);

        case PERFORMANCE_UPDATE_FEEDS:
            return {
                ...state,
                feedsIds: action.feedsIds,
                feeds: action.feeds,
                feedsPopupFetchFirstRun: false
            };

        case MOVE_NEW_GROUP_TO_CREATED:
            return moveNewGroupToCreatedReducer(state, action);

        case DELETE_RETARGETING_CONDITION_FROM_GROUP:
            return deleteRetargetingConditionFromGroup(state, action);

        case OPEN_GROUP_FILTER_INSPECTOR:
        case CLOSE_GROUP_FILTER_INSPECTOR:
        case UPDATE_FEED_FILTER_SCHEMA:
        case SET_FILTER_FEED_CATEGORIES:
        case SELECT_AUTOBUDGET_PRIORITY_TYPE:
        case UPDATE_AUTOBUDGET_PRICE:
        case UPDATE_SMART_FILTER_NAME:
        case ADD_SMART_FILTER:
        case UPDATE_SMART_FILTER:
        case UPDATE_SMART_FILTER_AUDITORY:
        case UPDATE_SMART_FILTER_PRICE_RANGE:
        case UPDATE_SMART_FILTER_VENDORS:
        case TOGGLE_SMART_FILTER_AVAILABLE:
        case UPDATE_SMART_FILTER_CATEGORIES:
        case CHANGE_SMART_FILTER_TAB:
        case SET_SMART_FILTER_VALIDATION_ERRORS:
        case UPDATE_FILTERS_ERROR:
        case UPDATE_SMART_FILTER_SUCCESS:
            return groupFilterInspectorReducer(state, action);

        case RESET_RETARGETING_ERRORS:
            return resetRetargetingErrors(state, action);
        case CLOSE_RECOMMENDATIONS_FOR_GROUPS_EDIT:
            return closeGroupsEditRecommendations(state, action);
        case UPDATE_RECOMMENDATIONS_FOR_GROUPS_EDIT:
            return updateRecommendationData(state, action);

        case CHANGE_PRIORITY_VALUE:
        case DROP_INTERNAL_GROUPS_FIELD_VALIDATION_ERRORS:
        case SAVE_INTERNAL_GROUPS:
            return internalGroups(state, action, fullState);

        case SAVE_GROUP_PI_TAGS_EDITOR:
            return saveGroupPITags(state, action);

        case CLEAR_ERRORS_PAGE_GROUP_TAGS:
            return clearErrorsPageGroupTags(state, action);

        case CLEAR_ERRORS_TARGET_TAGS:
            return clearErrorsTargetTags(state, action);

        case CHANGE_CONTENT_PROMOTION_GROUP:
            return changeContentPromotionGroup(state, action);

        case SAVE_GROUP_BEHAVIORS_CHANGES:
            return saveGroupBehaviors(state, action);
        default:
            return state;
    }
}

export function groupsMultiEdit(
    state: EditGroupsState = EditGroupsInitialState,
    action: Action,
    fullState: State
): EditGroupsState {
    return _groupsMultiEdit(groupsEditPreviewBannersReducer(state, action), action, fullState);
}
